import React from "react";

import "../assets/css/style.css"
import "../assets/css/reset.css"
import "../assets/css/responsive-leyouts.css"
import {email} from "../state/action";
import {useState} from "../state/useState";
import {EmailField} from "./EmailField";

export function Email() {

    let [state, dispatch] = useState();

    return <>
        <EmailField value={state.email}
                    placeholder={"Unesite email adresu"}
                    onChange={(address) => dispatch(email(address))}/>

    </>
}